import GradientBlur from "@/components/controls/GradientBlur";
import Text from "@/components/ui/text";
import { keys, map } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
  pageName: string;
  mainIcon: JSX.Element;
}

const EmptyPage: React.FC<Props> = ({ pageName, mainIcon }) => {
  const { t } = useTranslation();
  const sectionsTranslationKey = `${pageName}.empty.sections`;
  const sections = t(sectionsTranslationKey, { returnObjects: true });
  const sectionKeys = keys(sections);
  return (
    <div
      data-test={`${pageName}-page`}
      className="flex px-28 pt-32 pb-16 gap-10 justify-center"
    >
      <div className="flex flex-col gap-16 w-[20rem] md:w-[25rem] lg:w-[30rem] xl:w-[35rem]">
        <div className="flex flex-col gap-6">
          <span className="-translate-x-5">{mainIcon}</span>
          <Text variant="title1H1" className="text-5xl">
            {t(`${pageName}.title`)}
          </Text>
          <Text variant="twoXlH2">{t(`${pageName}.empty.subtitle`)}</Text>
        </div>
        <div className="h-fit w-fit px-3 py-2 rounded-full bg-surface-elevation1">
          <Text variant="lgLabel">{t("empty.comingSoon")}</Text>
        </div>
      </div>
      <div
        className="flex flex-col p-8 gap-6 rounded-lg border w-[25rem] md:w-[30rem] lg:w-[40rem] xl:w-[45rem]"
        style={{
          borderImage:
            "radial-gradient(circle at center, #5F50FF, #7F7BCC, #1E1C4C) 1",
          background:
            "radial-gradient(193.57% 162.69% at -5.11% -3.69%, rgba(100, 100, 120, 0.15) 0%, rgba(95, 80, 255, 0.08) 100%)",
          boxShadow: "0px 40px 32px 0px rgba(0, 0, 0, 0.06)",
          backdropFilter: "blur(10px)"
        }}
      >
        {map(sectionKeys, (section: string, index: number) => (
          <React.Fragment key={index}>
            <div className="flex flex-col gap-4">
              <Text variant="xlH1Medium">
                {t(`${sectionsTranslationKey}.${section}.title`)}
              </Text>
              <Text variant="lgBodySecondary">
                {t(`${sectionsTranslationKey}.${section}.subtitle`)}
              </Text>
            </div>
            {index < sectionKeys.length - 1 && (
              <div
                className="m-2 w-full h-[1px]"
                style={{
                  background:
                    "linear-gradient(90deg, rgba(77, 67, 191, 0.00) 0%, rgba(126, 116, 240, 0.86) 15%, var(--Purple-400, #867CF8) 85%, rgba(77, 67, 191, 0.00) 100%)"
                }}
              ></div>
            )}
          </React.Fragment>
        ))}
      </div>
      <GradientBlur className="top-[40rem] sm:left-[35rem] md:left-[40rem] lg:left-[45rem] xl:left-[50rem]" />
      <GradientBlur className="top-[40rem] sm:left-[45rem] md:left-[50rem] lg:left-[55rem] xl:left-[60rem]" />
    </div>
  );
};

export default EmptyPage;
